function getObj(key) {
  const item = localStorage.getItem(key);
  if (item === null) {
    return;
  }
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (err) {
    console.error(err);
  }
}

export default getObj;
